import React from "react";
import { TableBody } from "@mui/material";
import TableStyle from "../TableStyle";
import MyRow from "../Row/Row";
import { useShallowSelector } from "../../../hooks/useShallowSelector";
import Loading from "../../Loading/Loading";
import RootState from "../../../redux/types/rootState";
import {
  fetchBookings,
  setSelectedBooking,
} from "../../../redux/slice/bookingSlice";
import EmptyTablePlaceholder from "./EmptyTablePlaceHolder";
import { useSelector } from "react-redux";
import { convertFromBookingToSelectedBooking } from "../../../utils/converters";
import { useFetch } from "../../../hooks/useFetchAndGetSelected";
import { useAppDispatch } from "../../../redux/dispatch/useAppDispatch";
import { IBooking } from "../../../api/bookings/IBookings";

interface CustomTableBodyProps {
  handleEditClick: (dataSchema: IBooking) => void;
}

const CustomTableBody: React.FC<CustomTableBodyProps> = ({
  handleEditClick,
}) => {
  const classes = TableStyle();
  const selectedBookings = useShallowSelector(
    (state: RootState) => state.bookings.selectedBookings
  );
  const bookingsResponse = useSelector(
    (state: RootState) => state.bookings.bookingsResponse
  );
  const isLoading = useSelector((state: RootState) => state.bookings.isLoading);

  const dispatch = useAppDispatch();

  const bookings = bookingsResponse ? bookingsResponse.results : null;

  useFetch();

  if (bookings === null && isLoading) {
    return (
      <TableBody className={classes.tableBody}>
        <tr>
          <td>
            <Loading parentId="content-container-id" />
          </td>
        </tr>
      </TableBody>
    );
  } else if (bookings === null && !isLoading) {
    return (
      <TableBody className={classes.tableBody}>
        <EmptyTablePlaceholder
          text="No matching records found."
          refresh={() => dispatch(fetchBookings({page : 1}))}
        />
      </TableBody>
    );
  }
  //----

  const rows = bookings!;
  return (
    <TableBody className={classes.tableBody}>
      {isLoading ? <Loading parentId="content-container-id" /> : null}
      {rows.length === 0 ? (
        <EmptyTablePlaceholder
          text="No matching records found."
          refresh={() => dispatch(fetchBookings({page : 1}))}
        />
      ) : (
        rows.map((row, index) => (
          <MyRow
            key={index}
            classes={classes}
            row={row}
            handleEditClick={handleEditClick}
            handleCheckClick={(checked) => {
              if(bookings![index].status?.toUpperCase() !== "NEW") return;

              const selectedBooking = convertFromBookingToSelectedBooking(
                bookings![index]
              );

              if (!checked) {
                dispatch(
                  setSelectedBooking(
                    selectedBookings.filter(
                      (booking) => booking.id !== selectedBooking.id
                    )
                  )
                );
              } else {
                const hasSelectedBooking = selectedBookings.some(
                  (booking) => booking.id === selectedBooking.id
                );
                if (!hasSelectedBooking) {
                  dispatch(
                    setSelectedBooking([...selectedBookings, selectedBooking])
                  );
                }
              }
            }}
          />
        ))
      )}
    </TableBody>
  );
};

export default CustomTableBody;
